// // services/api.js
// // const API_BASE_URL = 'https://api.laminance.com/api';

// const API_BASE_URL = 'http://localhost:5000/api';



// class ApiService {
//   constructor() {
//     this.baseURL = API_BASE_URL;
//   }

//   async request(endpoint, options = {}) {
//     const url = `${this.baseURL}${endpoint}`;
    
//     console.log(`🔄 Making request to: ${url}`);
    
//     const config = {
//       mode: 'cors',
//       credentials: 'include', // 👈 THIS IS CRITICAL for sending cookies
//       headers: {
//         'Content-Type': 'application/json',
//         ...options.headers,
//       },
//       ...options,
//     };

//     if (config.body && typeof config.body === 'object') {
//       config.body = JSON.stringify(config.body);
//     }

//     try {
//       const response = await fetch(url, config);
      
//       if (response.status === 401) {
//         // Token expired or invalid
//         throw new Error('Authentication failed. Please login again.');
//       }
      
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }
      
//       const data = await response.json();
//       console.log(`✅ Request successful:`, data);
//       return data;
//     } catch (error) {
//       console.error('❌ API Request failed:', error);
//       throw new Error(`Network error: ${error.message}`);
//     }
//   }

//    // APPOINTMENT METHODS
//   async getAllAppointments() {
//     return this.request('/appointments', {
//       method: 'GET',
//     });
//   }

//   async getUserAppointments() {
//     return this.request('/appointments/user/my-appointments', {
//       method: 'GET',
//     });
//   }

//   async getAppointmentById(id) {
//     return this.request(`/appointments/${id}`, {
//       method: 'GET',
//     });
//   }

//   async getAppointmentsByDate(date) {
//     return this.request(`/appointments/date/${date}`, {
//       method: 'GET',
//     });
//   }

//   async createAppointment(appointmentData) {
//     return this.request('/appointments', {
//       method: 'POST',
//       body: appointmentData,
//     });
//   }

//   async updateAppointment(id, appointmentData) {
//     return this.request(`/appointments/${id}`, {
//       method: 'PUT',
//       body: appointmentData,
//     });
//   }

//   async deleteAppointment(id) {
//     return this.request(`/appointments/${id}`, {
//       method: 'DELETE',
//     });
//   }

//   async sendAppointmentEmail(id) {
//     return this.request(`/appointments/${id}/send-email`, {
//       method: 'POST',
//     });
//   }


//   // CONTACT METHODS
// async submitContact(contactData) {
//   return this.request('/contact/submit', {
//     method: 'POST',
//     body: contactData,
//   });
// }

// async getAllContacts(queryParams = {}) {
//   const params = new URLSearchParams(queryParams).toString();
//   const endpoint = params ? `/contact/admin/all?${params}` : '/contact/admin/all';
//   return this.request(endpoint);
// }

// async getContactStats() {
//   return this.request('/contact/admin/stats');
// }

// async updateContactStatus(id, statusData) {
//   return this.request(`/contact/admin/${id}/status`, {
//     method: 'PUT',
//     body: statusData,
//   });
// }

//   // ORDER METHODS
//   async createOrder(orderData) {
//     return this.request('/orders/create', {
//       method: 'POST',
//       body: orderData,
//     });
//   }

//   async getAllOrders() {
//     return this.request('/orders/all');
//   }

//   async getUserOrders() {
//     return this.request('/orders/my-orders');
//   }

//   async getOrders(queryParams = {}) {
//     const params = new URLSearchParams(queryParams).toString();
//     const endpoint = params ? `/orders/my-orders?${params}` : '/orders/my-orders';
//     return this.request(endpoint);
//   }

//   async getOrderById(orderId) {
//     return this.request(`/orders/${orderId}`);
//   }

//   async updateOrder(orderId, updateData) {
//     return this.request(`/orders/${orderId}`, {
//       method: 'PUT',
//       body: updateData,
//     });
//   }

//   async updateOrderStatus(orderId, status) {
//     return this.request(`/orders/${orderId}/status`, {
//       method: 'PUT',
//       body: { status },
//     });
//   }

//   async deleteOrder(orderId) {
//     return this.request(`/orders/${orderId}`, {
//       method: 'DELETE',
//     });
//   }

//   // Add authentication check method
//   async checkAuth() {
//     try {
//       const response = await this.request('/user/user-Detail');
//       return { isAuthenticated: true, user: response.data };
//     } catch (error) {
//       return { isAuthenticated: false, user: null };
//     }
//   }
// }

// export const apiService = new ApiService();




// services/api.js

// 🔁 Switch automatically based on environment
// const API_BASE_URL =
//   process.env.NODE_ENV === 'production'
//     ? 'https://api.laminance.com/api'
//     : 'http://localhost:5000/api';

// class ApiService {
//   constructor() {
//     this.baseURL = API_BASE_URL;
//   }

//   async request(endpoint, options = {}) {
//     const url = `${this.baseURL}${endpoint}`;
//     console.log(`🔄 API Request → ${url}`);

//     const config = {
//   credentials: 'include', // ✅ THIS FIXES 401
//   headers: {
//     'Content-Type': 'application/json',
//     ...(options.headers || {}),
//   },
//   ...options,
// };

//     // Convert body object → JSON
//     if (config.body && typeof config.body === 'object') {
//       config.body = JSON.stringify(config.body);
//     }

//     const response = await fetch(url, config);

//     let data = null;
//     try {
//       data = await response.json();
//     } catch (_) {
//       // ignore empty response
//     }

//     if (!response.ok) {
//       const message =
//         data?.message ||
//         data?.error ||
//         `Request failed with status ${response.status}`;

//       const error = new Error(message);
//       error.status = response.status;
//       error.data = data;
//       throw error;
//     }

//     return data;
//   }

//   /* =========================
//      CONTACT (NO EMAIL REQUIRED)
//      ========================= */

//   async submitContact(contactData) {
//     // contactData can be ANYTHING now
//     // { name?, phone?, message?, email? (optional) }
//     return this.request('/contact/submit', {
//       method: 'POST',
//       body: contactData,
//     });
//   }

//   async getAllContacts(query = {}) {
//     const params = new URLSearchParams(query).toString();
//     return this.request(
//       params ? `/contact/admin/all?${params}` : '/contact/admin/all'
//     );
//   }

//   async getContactStats() {
//     return this.request('/contact/admin/stats');
//   }

//   async updateContactStatus(id, statusData) {
//     return this.request(`/contact/admin/${id}/status`, {
//       method: 'PUT',
//       body: statusData,
//     });
//   }

//   /* =========================
//      APPOINTMENTS
//      ========================= */

//   async getAllAppointments() {
//     return this.request('/appointments');
//   }

//   async getUserAppointments() {
//     return this.request('/appointments/user/my-appointments');
//   }

//   async getAppointmentById(id) {
//     return this.request(`/appointments/${id}`);
//   }

//   async getAppointmentsByDate(date) {
//     return this.request(`/appointments/date/${date}`);
//   }

//   async createAppointment(data) {
//     return this.request('/appointments', {
//       method: 'POST',
//       body: data,
//     });
//   }

//   async updateAppointment(id, data) {
//     return this.request(`/appointments/${id}`, {
//       method: 'PUT',
//       body: data,
//     });
//   }

//   async deleteAppointment(id) {
//     return this.request(`/appointments/${id}`, {
//       method: 'DELETE',
//     });
//   }

//   async sendAppointmentEmail(id) {
//     return this.request(`/appointments/${id}/send-email`, {
//       method: 'POST',
//     });
//   }

//   /* =========================
//      ORDERS
//      ========================= */

//   async createOrder(orderData) {
//     return this.request('/orders/create', {
//       method: 'POST',
//       body: orderData,
//     });
//   }

//   async getAllOrders() {
//     return this.request('/orders/all');
//   }

//   async getUserOrders() {
//     return this.request('/orders/my-orders');
//   }

//   async getOrderById(orderId) {
//     return this.request(`/orders/${orderId}`);
//   }

//   async updateOrder(orderId, data) {
//     return this.request(`/orders/${orderId}`, {
//       method: 'PUT',
//       body: data,
//     });
//   }

//   async updateOrderStatus(orderId, status) {
//     return this.request(`/orders/${orderId}/status`, {
//       method: 'PUT',
//       body: { status },
//     });
//   }

//   async deleteOrder(orderId) {
//     return this.request(`/orders/${orderId}`, {
//       method: 'DELETE',
//     });
//   }
// }

// export const apiService = new ApiService();





// 🔁 Switch automatically based on environment
const API_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://api.laminance.com/api'
    : 'http://localhost:5000/api';

console.log('🌍 Environment:', process.env.NODE_ENV || 'development');
console.log('🔗 API Base URL:', API_BASE_URL);

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    console.log(`🔄 API Request → ${url}`);

    // Determine if this endpoint needs credentials
    const needsAuth = endpoint.includes('/admin/') || 
                     endpoint.includes('/user/') || 
                     endpoint.includes('/orders/') ||
                     endpoint.includes('/appointments/');

    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
      ...options,
    };

    // Only add credentials for authenticated endpoints
    // Contact form (public) doesn't need credentials
    if (needsAuth) {
      config.credentials = 'include';
    }

    // Convert body object → JSON
    if (config.body && typeof config.body === 'object') {
      config.body = JSON.stringify(config.body);
    }

    try {
      const response = await fetch(url, config);

      let data = null;
      const contentType = response.headers.get('content-type');
      
      if (contentType && contentType.includes('application/json')) {
        try {
          data = await response.json();
        } catch (e) {
          console.warn('Failed to parse JSON:', e);
        }
      } else {
        const text = await response.text();
        console.log('Non-JSON response:', text.substring(0, 200));
        data = { message: text };
      }

      if (!response.ok) {
        const message =
          data?.message ||
          data?.error ||
          `Request failed with status ${response.status}`;

        const error = new Error(message);
        error.status = response.status;
        error.data = data;
        throw error;
      }

      return data;
    } catch (error) {
      console.error('❌ API Error:', {
        endpoint,
        error: error.message,
        status: error.status
      });
      
      // User-friendly error messages
      let userMessage = error.message;
      
      if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
        userMessage = process.env.NODE_ENV === 'production'
          ? 'Unable to reach server. Please try again later.'
          : 'Cannot connect to server. Make sure backend is running.';
      } else if (error.message.includes('timeout')) {
        userMessage = 'Request timeout. Please try again.';
      }
      
      throw new Error(userMessage);
    }
  }

  /* =========================
     CONTACT FORM (PUBLIC - NO AUTH)
     ========================= */

  async submitContact(contactData) {
    console.log('📝 Submitting contact form');
    return this.request('/contact/submit', {
      method: 'POST',
      body: contactData,
    });
  }

  /* =========================
     CONTACT ADMIN (AUTH NEEDED)
     ========================= */

  async getAllContacts(query = {}) {
    const params = new URLSearchParams(query).toString();
    return this.request(
      params ? `/contact/admin/all?${params}` : '/contact/admin/all'
    );
  }

  async getContactStats() {
    return this.request('/contact/admin/stats');
  }

  async updateContactStatus(id, statusData) {
    return this.request(`/contact/admin/${id}/status`, {
      method: 'PUT',
      body: statusData,
    });
  }

  /* =========================
     APPOINTMENTS (AUTH NEEDED)
     ========================= */

  async getAllAppointments() {
    return this.request('/appointments');
  }

  async getUserAppointments() {
    return this.request('/appointments/user/my-appointments');
  }

  async getAppointmentById(id) {
    return this.request(`/appointments/${id}`);
  }

  async getAppointmentsByDate(date) {
    return this.request(`/appointments/date/${date}`);
  }

  async createAppointment(data) {
    return this.request('/appointments', {
      method: 'POST',
      body: data,
    });
  }

  async updateAppointment(id, data) {
    return this.request(`/appointments/${id}`, {
      method: 'PUT',
      body: data,
    });
  }

  async deleteAppointment(id) {
    return this.request(`/appointments/${id}`, {
      method: 'DELETE',
    });
  }

  async sendAppointmentEmail(id) {
    return this.request(`/appointments/${id}/send-email`, {
      method: 'POST',
    });
  }

  /* =========================
     ORDERS (AUTH NEEDED)
     ========================= */

  async createOrder(orderData) {
    return this.request('/orders/create', {
      method: 'POST',
      body: orderData,
    });
  }

  async getAllOrders() {
    return this.request('/orders/all');
  }

  async getUserOrders() {
    return this.request('/orders/my-orders');
  }

  async getOrderById(orderId) {
    return this.request(`/orders/${orderId}`);
  }

  async updateOrder(orderId, data) {
    return this.request(`/orders/${orderId}`, {
      method: 'PUT',
      body: data,
    });
  }

  async updateOrderStatus(orderId, status) {
    return this.request(`/orders/${orderId}/status`, {
      method: 'PUT',
      body: { status },
    });
  }

  async deleteOrder(orderId) {
    return this.request(`/orders/${orderId}`, {
      method: 'DELETE',
    });
  }

  /* =========================
     UTILITY METHODS
     ========================= */

  async testConnection() {
    try {
      const response = await fetch(`${this.baseURL}/test`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
      });
      
      if (response.ok) {
        const data = await response.json();
        return { success: true, data };
      }
      return { success: false, status: response.status };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }

  async getHealth() {
    return this.request('/health', { method: 'GET' });
  }
}

export const apiService = new ApiService();
